import React from 'react'
import Modal from 'react-bootstrap/Modal'

const DateModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      style={{
        userSelect: 'none',
      }}
      size={20}
      //   backdrop='static'
      centered
    >
      <Modal.Body className=''>
        {props.data?.map((item) => (
          <div
            className='ilceItem'
            key={item.date}
            onClick={() => {
              
              const newSayi = item?.hours?.length === 1 ? item?.hours[0]?.sayi : null
              const newHour = item?.hours?.length === 1 ? item?.hours[0]?.hour : null
              const newHourId = item?.hours?.length === 1 ? item?.hours[0]?.hour_id : null
              const newDoluluk = item?.hours?.length === 1 ? item?.hours[0]?.doluluk : null
              const kalan_bilet = item?.hours?.length === 1 ? item?.hours[0]?.kalan_bilet : null
              const kalanKullanimHakki = item?.hours?.length === 1 ? item?.hours[0]?.kalan_kullanim_hakki : null

              props.setSayi(newSayi)
              props.setSelectedDate(item.date)
              props.setSelectedDateId(item.date_id)
              props.setDoluluk(newDoluluk)
              props.setSelectedSeans(newHour)
              props.setSelectedSeansId(newHourId)

              if (kalan_bilet) {
                props.setTicketCount(kalan_bilet < kalanKullanimHakki ? kalan_bilet : kalanKullanimHakki)
                props.setKalanBiletSayisi(kalan_bilet)
              }
              props.onHide()
            }}
          >
            {item.date?.split('-').reverse().join('-')}
          </div>
        ))}
        <div
          style={{ position: 'absolute', top: '15px', right: '15px' }}
          onClick={props.onHide}
        >
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DateModal
